export const RQ_SEARCH_CAMPAIGN_DASHBOARD_ENROLLMENTS_API = {
  url: 'v2/campaign-dashboard/enrollments/<%= locationId %>',
  method: 'GET',
  auth: true,
  search: true,
};
